import { RegistrySetRequestTypes } from './actionTypes';

const INIT_STATE = {
    listData: [],
    error: {},
    success: '',
    CountItems: 0,
    filterItems: [],
    loading: false,
    CountBranding: undefined
};

const RegistrySetRequest = (state = INIT_STATE, action: any) => {
    switch (action.type) {

        case RegistrySetRequestTypes.GET_TRANSACTION_LIST:
            return {
                ...state,
                loading: true
            };

        case RegistrySetRequestTypes.GET_TRANSACTION_LIST_SUCCESS:
            return {
                ...state,
                listData: action.payload.listData,
                CountItems: action.payload.CountItems,
                loading: false,
            };

        case RegistrySetRequestTypes.GET_TRANSACTION_LIST_ERROR:
            return {
                ...state,
                error: action.payload,
                listData: [],
                loading: false,
            };

        //-----------------------filter--------------------------------
        case RegistrySetRequestTypes.GET_FILTER_LIST:
            state = {
                ...state,
                loading: true
            };
            break;

        case RegistrySetRequestTypes.GET_FILTER_LIST_SUCCESS:
            return {
                ...state,
                filterItems: action.payload.filterItems,
                loading: false,
            };

        case RegistrySetRequestTypes.GET_FILTER_LIST_ERROR:
            return {
                ...state,
                error: action.payload,
                listData: [],
                loading: false,
            };

        //-----------------------Count--------------------------------
        case RegistrySetRequestTypes.GET_TRANSACTION_COUNT:
            state = {
                ...state,
                loading: true
            };
            break;

        case RegistrySetRequestTypes.GET_TRANSACTION_COUNT_SUCCESS:
            return {
                ...state,
                CountBranding: action.payload.CountItems,
                loading: false,
            };

        case RegistrySetRequestTypes.GET_TRANSACTION_COUNT_ERROR:
            return {
                ...state,
                error: action.payload,
                listData: [],
                loading: false,
            };

        default:
            break;
    }

    return state;
};

export default RegistrySetRequest;
